export default "__VITE_ASSET__DfUyo9YB__"